import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, countries, gamesCasino, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableProductsCryptoNetworkView.
 * @extends JetView - Base class for Webix Jet views.
 */
export default class tableProductsCryptoNetworksView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns Object The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        return {
            rows: [
                {
                    id: 'preloader', // ID for preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: _('Acciones'), // Column header
                                    width: 100, // Column width
                                    height: 25, // Column height
                                    /**
                                     * Generates HTML content for action icons based on user permissions.
                                     * @method template
                                     * @param {object} obj The object containing data or context for the template.
                                     * @returns {string} The HTML string with action icons, or an empty string if no icons are displayed.
                                     * @description This function checks the user's permissions for viewing or editing actions and generates HTML content accordingly.
                                     * If the user has permission to view or edit products, respective icons are added to the content.
                                     * The content is then wrapped in a flex container if any icons are present, ensuring they are centered.
                                     */
                                    template: function (obj) {
                                        let content = '';

                                        if (devConfig.getPermAction('productsCryptoNetworkView', 'Edit')) {
                                            content += "<span class='webix_icon wxi-search view' style='margin-right:8px; cursor:pointer;'></span>";
                                        }

                                        if (devConfig.getPermAction('productsCryptoNetworkEdit', 'Edit')) {
                                            content += "<span class='webix_icon wxi-close edit'></span>";
                                        }

                                        // If there's at least one icon, we center the container.
                                        if (content) {
                                            return "<div style='display:flex; justify-content:center; align-items:center; height:100%'>" + content + "</div>";
                                        } else {
                                            return '';
                                        }
                                    }
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 55, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'nameProvider', // Column ID
                                    header: _('Proveedor'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'productName', // Column ID
                                    header: _('Producto Técnico'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'cryptoCurrencyName', // Column ID
                                    header: _('Cripto'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'networkName', // Column ID
                                    header: _('Red'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'networkCode', // Column ID
                                    header: _('Código de Red'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activa') },
                                        { id: 'I', value: _('Inactiva') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'partnerCountry', // Column ID
                                    header: _('Partner/País'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("editform").setValues(item); // Set form values to the clicked item
                                    $$('editwinProductsCryptoNetwork').show(); // Show edit window on click
                                },
                                view: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("viewform").setValues(item); // Set form values to the clicked item
                                    $$('viewwinProductsCryptoNetwork').show(); // Show edit window on click
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // API URL for fetching data
                            url:
                                devConfig.geturlApi() +
                                'CryptoNetworksProduct/GetCryptoProduct?Partner=' +
                                id_partner +
                                '&',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // Store the URL for data fetching
        var filter = ''; // Initialize filter variable
        var optionsCategorias = []; // Initialize options for categories
        var popup = webix.ui({
            // Create edit window UI
            view: 'window',
            id: 'editwinProductsCryptoNetwork', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 700 : 350, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Formulario de Edición Producto Cripto') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for editing
                    id: 'editform', // ID for the form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Proveedor'),
                            name: 'nameProvider',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Producto'),
                            name: 'productName',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for CryptoCurrency
                            label: _('Criptomoneda + Red Blockchain'),
                            name: 'nameCryptoNetwork',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Partner/Country
                            label: _('Partner/País'),
                            name: 'partnerCountry',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'State',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activa') },
                                { id: 'I', value: _('Inactiva') },
                            ],
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            required: true, // Required field
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('editform').getValues(); // Get form values
                                        var form = $$('editform');

                                        if (!form.validate()) {
                                            webix.message({ type: "error", text: _("Por favor, completa todos los campos obligatorios.") });
                                            return;
                                        }
                                        values.Partner = id_partner; // Add partner ID to values
                                        webix
                                            .ajax() // AJAX request to save changes
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'CryptoNetworksProduct/UpdateGroupCryptoProduct',
                                                '{"Id":' +
                                                values.Id +
                                                ',"providerId":"' +
                                                values.providerId +
                                                '","productPartnerCountryId":"' +
                                                values.productPartnerCountryId +
                                                '","cryptoNetworskId":"' +
                                                values.cryptoNetworskId +
                                                '","Partner":"' +
                                                values.Partner +
                                                '","State":"' +
                                                values.State +
                                                '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Producto a CriptoRed Editada', // Success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide window after saving
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var viewPopup = webix.ui({
            // Create edit window UI
            view: 'window',
            id: 'viewwinProductsCryptoNetwork', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 700 : 350, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Visualización de Producto Cripto') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for editing
                    id: 'viewform', // ID for the form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelWidth: 160,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Proveedor'),
                            name: 'nameProvider',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Producto'),
                            name: 'productName',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for CryptoCurrency
                            label: _('Criptomoneda + Red Blockchain'),
                            name: 'nameCryptoNetwork',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Partner/Country
                            label: _('Partner/País'),
                            name: 'partnerCountry',
                            readonly: true, // Read-only field
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'State',
                            labelWidth: 160,
                            inputWidth: 410,   // width of the input
                            readonly: true,
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activa') },
                                { id: 'I', value: _('Inactiva') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cerrar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var vthis = this; // Preserve context for event handlers
        this.on(this.app, 'productsCryptoNetworks:filter', (filterData) => {
            // Event handler for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload grid data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.refreshColumns(); // Refresh columns after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload grid data with sorting
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item clicks
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data for selected player
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to fetch initial data
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'CryptoNetworksProduct/GetCryptoProduct', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    for (var i = 0; i < resp.data.length; i++) {
                        resp.data[i].id = resp.data[i].Id; // Map ID
                        resp.data[i].value = resp.data[i].Description; // Map description
                    }
                    optionsCategorias = resp.data; // Store options for categories
                    var selectedProviderId = null;
                    var popupAdd = webix.ui({
                        // Create add product window UI
                        view: 'window',
                        id: 'ProductCryptoNetworkAdd', // ID for the add window
                        autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
                        minHeight: screen.width < 500 ? 660 : 300, // Height based on screen size
                        autoheight: true, // Auto height based on content
                        head: {
                            view: 'toolbar', // Toolbar for the window header
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Asociación de Producto Cripto'), // Label for the window
                                },
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the window
                        modal: true, // Modal window
                        body: {
                            view: 'scrollview', // Scrollable body
                            scroll: 'y',
                            body: {
                                view: 'form', // Form for adding product
                                id: 'addformPB', // ID for the form
                                width: screen.width < 500 ? 350 : 450, // Width based on screen size
                                elements: [
                                    {
                                        view: 'richselect', // Rich select for country selection
                                        name: 'CountrySelect',
                                        id: 'CountrySelect',
                                        localId: 'regions:combo',
                                        labelWidth: 160,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        label: "<span class='icon-language'></span>" + _('País'), // Localized label
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                        on: {
                                            onChange: function (data, obj) {
                                                var providerCombo = $$('providerId');
                                                var productCombo = $$('productPartnerCountryId');

                                                providerCombo.setValue("");
                                                providerCombo.getList().clearAll();


                                                productCombo.setValue("");
                                                productCombo.getList().clearAll();

                                                var currentValue = this.getValue(); // Get current value
                                                if (currentValue.length > 0) {
                                                    $$('button').enable(); // Enable button if value is selected
                                                } else {
                                                    $$('button').disable(); // Disable button if no value
                                                }
                                            },
                                        },
                                        options: {
                                            body: {
                                                template: function (obj) {
                                                    // Template for displaying country options
                                                    return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                                },
                                                data: countries, // Country data
                                            },
                                        },
                                        hidden: !devConfig.getPermAction(
                                            // Hide if permission denied
                                            'filterByCountry',
                                            'Add',
                                        ),
                                        css: 'prm-filterByCountry', // CSS class for styling
                                    },
                                    {
                                        view: 'combo', // Combo box for provider selection
                                        name: 'providerId',
                                        id: 'providerId',
                                        localId: 'provider:combo',
                                        label: _('Proveedor'), // Localized label
                                        labelWidth: 160,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                        options: {
                                            body: {
                                                dataFeed: function (text) {
                                                    // Data feed function for provider options
                                                    var vthis = this;
                                                    var countrySelectValue = $$('CountrySelect').getValue();

                                                    if (!countrySelectValue || countrySelectValue.length === 0) {
                                                        webix.message("Primero selecciona un país");
                                                        return;
                                                    }
                                                    if (countrySelectValue) {
                                                        // Fetch data if input length is greater than 2
                                                        if (text.length > 2) {
                                                            vthis.clearAll();
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'es/Select/GetProviders',
                                                                    '{"Filter":"' + text + '","Partner":"' + id_partner + '","Country":"' + countrySelectValue + '"}',
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(
                                                                                'Error! ', // Error message on failure
                                                                            );
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var resp = JSON.parse(text); // Parse response
                                                                            if (!resp.HasError) {
                                                                                vthis.parse(
                                                                                    resp.Data, // Parse data into combo
                                                                                );
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    }
                                                },
                                            },
                                        },
                                        on: {
                                            onChange: function (newId) {
                                                selectedProviderId = newId;
                                                var productCombo = $$('productPartnerCountryId');
                                                productCombo.setValue("");
                                                productCombo.getList().clearAll();
                                            },
                                        },

                                    },
                                    {
                                        view: 'combo', // Combo box for provider selection
                                        name: 'productPartnerCountryId',
                                        id: 'productPartnerCountryId',
                                        localId: 'product:combo',
                                        label: _('Producto'), // Localized label
                                        labelWidth: 160,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                        options: {
                                            body: {
                                                dataFeed: function (text) {
                                                    // Data feed function for provider options
                                                    var vthis = this;
                                                    if (!selectedProviderId || selectedProviderId.length === 0) {
                                                        webix.message("Primero selecciona un proveedor");
                                                        return;
                                                    }
                                                    if (selectedProviderId) {
                                                        // Fetch data if input length is greater than 2
                                                        if (text.length > 2) {
                                                            var countrySelectValue = $$('CountrySelect').getValue(); // Get selected country value
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'es/Select/GetProducts',
                                                                    '{"Filter":"' + text + '","ProviderId":"' + selectedProviderId + '","Partner":"' + id_partner + '","Country":"' + countrySelectValue + '"}',
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(
                                                                                'Error! ', // Error message on failure
                                                                            );
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var resp = JSON.parse(text); // Parse response
                                                                            if (!resp.HasError) {
                                                                                vthis.parse(
                                                                                    resp.Data, // Parse data into combo
                                                                                );
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        }
                                                    }
                                                },
                                            },
                                        },
                                    },
                                    {
                                        view: 'combo', // Combo box for CryptoCurrencies selection
                                        name: 'cryptoNetworksId',
                                        id: 'cryptoNetworksId',
                                        localId: 'cryptoNetworks:combo',
                                        label: _('Criptomoneda + Red Blockchain'), // Localized label
                                        labelWidth: 160,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                        options: {
                                            body: {
                                                data: []
                                            }
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var combo = this.getPopup().getList();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(
                                                        devConfig.geturlApi() + 'es/Select/GetCryptoNetworks',
                                                        '{"Filter":"btc"}',
                                                        {
                                                            success: function (text) {
                                                                var resp = JSON.parse(text);
                                                                if (!resp.HasError) {
                                                                    combo.parse(resp.Data);
                                                                    combo.getParentView().showPopup();
                                                                }
                                                            }
                                                        }
                                                    );
                                            }
                                        }
                                    },
                                    {
                                        view: 'combo', // Combo box for activation status
                                        label: _('Estado'),
                                        name: 'State',
                                        labelWidth: 160,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        options: [
                                            {
                                                id: 'A',
                                                value: _('Activa'), // Localized value
                                            },
                                            {
                                                id: 'I',
                                                value: _('Inactiva'), // Localized value
                                            },
                                        ],
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                    },
                                    {
                                        cols: [
                                            // Button layout
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'),
                                                click: function () {
                                                    this.getTopParentView().hide();
                                                    $$('addformPB').clear();
                                                    $$('cryptoNetworksId').setValue("");
                                                    $$('State').setValue("");
                                                    $$('providerId').getList().clearAll();
                                                    $$('productPartnerCountryId').getList().clearAll();
                                                }
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function ($e) {
                                                    var values = $$('addformPB').getValues(); // Get form values
                                                    var form = $$('addformPB');

                                                    if (!form.validate()) {
                                                        webix.message({ type: "error", text: _("Por favor, completa todos los campos obligatorios.") });
                                                        return;
                                                    }
                                                    values.Partner = id_partner; // Add partner ID to values
                                                    webix
                                                        .ajax() // AJAX request to save new product
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                            'CryptoNetworksProduct/SaveGroupCryptoProduct',
                                                            '{"providerId":"' +
                                                            values.providerId +
                                                            '", "productPartnerCountryId":"' +
                                                            values.productPartnerCountryId +
                                                            '", "cryptoNetworksId":"' +
                                                            values.cryptoNetworksId +
                                                            '", "State":"' +
                                                            values.State +
                                                            '", "Partner":"' +
                                                            id_partner +
                                                            '"}',
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error! ', // Error message on failure
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Categoría Producto Agregada', // Success message
                                                                    );
                                                                    grid.clearAll(); // Clear grid data
                                                                    grid.load(
                                                                        url +
                                                                        '?start=0&count=' +
                                                                        grid.data.$pagesize +
                                                                        filter, // Reload grid data
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    this.getTopParentView().hide(); // Hide window after saving
                                                    $$('addformPB').clear();
                                                    $$('cryptoNetworksId').setValue("");
                                                    $$('State').setValue("");
                                                    $$('providerId').getList().clearAll();
                                                    $$('productPartnerCountryId').getList().clearAll();
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    vthis.on(vthis.app, 'addProductCryptoNetwork:button', (filter) => {
                        popupAdd.show(); // Show add product window
                    });
                },
            });
    }
}

// FILE DOCUMENTED
